module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-class=[$ctrl.inputClass] class=form-field-input> <custom-dropdown empty-display-name=\"''\" is-invalid=$ctrl.parentForm[$ctrl.fieldName].$invalid item-display-prop=$ctrl.displayProp item-list=$ctrl.itemList field-name=$ctrl.fieldName on-item-select=\"$ctrl.setItem({field: $ctrl.fieldName, item: item})\" is-required=$ctrl.isRequired selected-display=$ctrl.selectedItem> </custom-dropdown> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/select-field/select-field.html
// module id = 347
// module chunks = 0